import { api } from "@";

// Function to get a list of messages with pagination and search
export const getMessages = (page = 1, perSize, search) => {
  return api.post(
    `/api/MessageConfiguration/search?SearchKey=${search}&Page=${page}&PageSize=${perSize}`,
  );
};

// Function to toggle the active status of a message
export const toggleActive = (id, value) =>
  api.put(`/api/MessageConfiguration/${id}/status?status=${value}`);

// Function to save a message's data (create or update)
export const saveMessage = (form) => {
  if (form.id) {
    return api.put(`/api/MessageConfiguration/${form.id}`, form);
  }
  return api.post("/api/MessageConfiguration/add", form);
};

// get goals
export const getGoals = async () => {
  try {
    const { data: goals } = await api.get(`/api/Lookup/all`);
    return goals;
  } catch (error) {
    return [];
  }
};

// get Constants based on message key
export const getConstants = async (messageKey) => {
  try {
    const res = await api.get(
      `/api/MessageConfiguration/message-goals/${messageKey}`,
    );
    return res?.data;
  } catch (error) {
    return [];
  }
};
